import React from 'react';
import { LoaderCircle } from '@vr/lib';

export default function MapLoader() {
  return (
    <div className="google-places-autocomplete__suggestions-container">
      <LoaderCircle />
    </div>
  );
}
